'use strict';

angular.module('dashboard')

.config(function ($stateProvider)
{
    $stateProvider.state('app.dashboard', {
        url: '/',
        templateUrl: 'modules/dashboard/dashboard.html',
        controller: 'DashboardCtrl',
        resolve: {
            programmes: ['Programme', function(Programme)
            {
                Programme.ejectAll();

                var params = {
                    where: {
                        language_id: {
                            '==': 0
                        }
                    },
                    sort: 'display_order'
                };

                return Programme.findAll(params, {
                    bypassCache: true
                });
            }],
            seasons: ['Season', function(Season)
            {
                var params = {
                    sort: 'display_order'
                };

                return Season.findAll(params, {
                    bypassCache: true
                });
            }],
            languages: ['Language', function(Language)
            {
                return Language.findAll();
            }]
        }
    });
});
